<template>
  <el-container class="container">
    <!-- 头部：logo、系统名称、头像退出 -->
    <el-header style="height: 75px;">
      <div class="header">
        <div class="logo">
          <img src="../../assets/image/logo1.png" alt="" />
        </div>
        <div class="header-right">
          <div class="username">
            {{ username }}
          </div>
          <div class="logout" @click="logout">
            <!-- <a class="el-icon-user" @click="userInfo()"></a> -->
            <a href="#">退出</a>
            <i class="iconfont icontuichu"></i>
          </div>
        </div>
      </div>
    </el-header>

    <el-container>
      <!-- 侧边栏导航 -->
      <el-aside class="aside" width="240">
        <el-menu :unique-opened="true" :router="true" text-color="#fff">
          <el-submenu v-for="item in menus.data" :key="item.id" :index="item.id.toString()">
            <template slot="title">
              <!-- <i class="el-icon-location"></i> -->
              <span class="span-icon"><i :class="iconObj[item.id]"></i></span>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item class="el-icon-s-unfold" :index="itemSub.path" v-for="itemSub in item.children"
              :key="itemSub.id">
              {{ itemSub.name }}
            </el-menu-item>
          </el-submenu>
        </el-menu>

      </el-aside>

      <!-- 内容区 -->
      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      menus: {},
      iconObj: {
        '1': 'iconfont iconzhuanjiafuwu',
        '2': 'iconfont iconzhuanjiawangluo',
        '3': 'iconfont iconleibie',
        '4': 'iconfont iconxiangmu',
        '5': 'iconfont iconfenpei',
        '6': 'iconfont iconpingjiapingshen',
        '7': 'iconfont iconshezhi',
        '8': 'iconfont iconyonghu',
        '9': 'iconfont iconfile',
        '10': 'iconfont iconjiancha',
        '11': 'iconfont iconyanshou',
        '12': 'iconfont iconcaiwu',
        '13': 'iconfont iconshangchuan', //20241212 上传测试报告
      },
    }
  },
  created() {

    //请求携带token
    this.axios.defaults.headers['token'] = localStorage.getItem('token')

    // 获取菜单
    const menus = localStorage.getItem("menus")
    this.menus = JSON.parse(menus)
    this.username = localStorage.getItem("username")

    //如果没有，跳转登录
    // if (!token) {
    //   this.$router.push({ name: "login" })
    // }
    //如果有，继续渲染
  },
  methods: {
    logout() {
      //清除token
      localStorage.clear()
      this.$message.success("退出成功")
      this.$router.push({
        name: "login"
      })
    },
    userInfo() {
      alert('hei')
    }
  },
}

</script>

<style lang="less">
.container {
  height: 100%;

  .el-header {
    .header {
      width: 100%;
      height: 74px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;

      .logo {
        margin-top: 7px;
        margin-bottom: 7px;
        margin-left: 4px;
      }

      .header-right {
        display: flex;
        justify-content: end;

        .username {
          display: flex;
          justify-content: center;
          align-items: center;
          padding-right: 10px;
          font-size: 20px;
        }
      }

      .logout {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 10px;
        font-size: 14px;
        color: #007ec7;
        height: 74px;
        cursor: pointer;

        a {
          text-decoration: none;
          font-size: 16px;
          color: #007ec7;
          margin-right: 10px;
        }

        i {
          font-size: 25px;
        }
      }
    }
  }
}

.aside {
  background-color: #1c4259;

  .el-menu {
    width: 240px;
    background-color: #1c4259;
    border-right: 1px solid #1c4259;
  }

  .span-icon {
    margin-left: 2px;
    margin-right: 6px;

    .iconfont {
      font-size: 22px;
    }
  }
}

.main {
  background-color: #fff;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue